module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline pb-0"
  }, [(_vm.withClose) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v("\n    " + _vm._s(_vm.dateRangeString) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "nudge-bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "small": "",
            "icon": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("arrow_drop_down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.actions), function(action) {
    return _c('v-list-tile', {
      key: action.id,
      on: {
        "click": action.onclick
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(action.title))])], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), (_vm.showFilters) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.filters), function(filter) {
    return _c('v-list-tile', {
      key: filter
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(filter) + "\n          ")])], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('v-date-picker', {
    staticClass: "elevation-0 mb-0 pb-0",
    attrs: {
      "flat": "",
      "full-width": "",
      "no-title": "",
      "no-messages": "",
      "pickerDate": _vm.pickerDate,
      "multiple": _vm.calendarType === "date",
      "type": _vm.calendarType
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  }), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-0"
  }, [(_vm.withMonthPicker) ? [(_vm.calendarType == "date") ? _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "outlined": "",
      "flat": ""
    },
    on: {
      "click": _vm.setMonthPicker
    }
  }, [_vm._v("Month picker")]) : _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "outlined": "",
      "flat": ""
    },
    on: {
      "click": _vm.setDatePicker
    }
  }, [_vm._v("Date picker")])] : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withOk) ? _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("OK")]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52dff178","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/DateRangePicker.vue
// module id = 1425
// module chunks = 9